import { Center } from "@chakra-ui/react";

function PipelineLockedIndicator() {
    return (
        <Center
            position={"fixed"}
            zIndex={10000}
            w={"100%"}
            h={"100%"}
            left={0}
            top={0}
            backgroundColor={"#80808099"}
        >
            Pipeline is being edited by another client
        </Center>
    );
}

export default PipelineLockedIndicator;
